import { ProfileReportItem } from '../../../../models';
import { FormBuilder, FormControl } from '@angular/forms';

export class ShipmentProfileReport {
  includeAllFields = false;
  waybill: ProfileReportItem[] = [];
  load: ProfileReportItem[] = [];
  to: ProfileReportItem[] = [];

  constructor(params?: ShipmentProfileReport) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class ShipmentProfileReportForm {
  constructor(
    model: Partial<ShipmentProfileReport>,
    fb: FormBuilder = new FormBuilder(),
    public includeAllFields: FormControl<boolean> = fb.control<boolean>(model.includeAllFields, []),
    public waybill: FormControl<ProfileReportItem[]> = fb.control<ProfileReportItem[]>(model.waybill, []),
    public load: FormControl<ProfileReportItem[]> = fb.control<ProfileReportItem[]>(model.load, []),
    public to: FormControl<ProfileReportItem[]> = fb.control<ProfileReportItem[]>(model.to, []),
  ) {}
}
